import type {
  SnackbarAnchor,
  SnackbarComponentConfig,
} from '@unifyapps/defs/types/interface/components/Snackbar/type';
import type { ToasterProps } from 'sonner';
import { TOAST_COLOR_TO_ICON } from './constants';
import type { SnackbarProps } from './types';

export const getStartDecoratorComponent = ({
  color = 'default',
  startDecoratorNode,
  startDecoratorComponent,
}: {
  color: SnackbarProps['color'];
  startDecoratorNode: SnackbarProps['startDecoratorNode'];
  startDecoratorComponent: SnackbarProps['startDecoratorComponent'];
}) => {
  // when no startDecoratorNode and no startDecoratorComponent is provided, we use the default icon

  return !startDecoratorNode && !startDecoratorComponent
    ? TOAST_COLOR_TO_ICON[color]
    : startDecoratorComponent;
};

export const getAutoHideDuration = ({
  autoHideDuration,
  color,
}: {
  autoHideDuration: SnackbarProps['autoHideDuration'];
  color: SnackbarProps['color'];
}) => {
  return autoHideDuration ?? (color === 'warning' ? 5000 : 3000);
};

const PositionMap: Record<SnackbarAnchor, ToasterProps['position']> = {
  TOP_CENTER: 'top-center',
  BOTTOM_CENTER: 'bottom-center',
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
};

export const getSnackbarPosition = (
  snackbarConponentConfig?: SnackbarComponentConfig,
): ToasterProps['position'] => {
  if (!snackbarConponentConfig) {
    return 'top-right';
  }

  return PositionMap[snackbarConponentConfig.anchor];
};

export const getSnackbarCoordinateStyle = (snackbarConponentConfig?: SnackbarComponentConfig) => {
  if (!snackbarConponentConfig) {
    return undefined;
  }

  return snackbarConponentConfig.coordinates;
};
